import { useForm } from 'react-hook-form';
import { translate } from 'javascripts/translations/i18n';
import toast from 'helpers/toast';
import { useSetReminderMutation } from './useSetReminderMutation';
import { delayOptions } from '../constants';
import { useBackwardsCompatibleNavigate } from 'components/navigation/useBackwardsCompatibleNavigation';

const getDelayLabel = (delay: string) => {
  const selectedOption = delayOptions.find((option) => option.value === delay);
  return selectedOption ? selectedOption.label.toLowerCase() : '';
};

export const useSetReminderForm = (
  reminderType: string,
  reminderId: string,
) => {
  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useBackwardsCompatibleNavigate();
  const setReminderMutation = useSetReminderMutation(
    reminderType,
    reminderId,
    () => {
      toast.success(
        translate('reminders.successMessage', {
          delaySelected: getDelayLabel(getValues('delay')),
        }),
        translate('reminders.successButtonText'),
        () => {
          navigate('/notifications');
        },
        6,
      );
    },
    () => {
      toast.error(translate('reminders.errorMessage'));
    },
  );

  const onSubmit = async (data: { delay: string }) => {
    setReminderMutation.mutate({
      delay: data.delay,
    });
  };

  return {
    register,
    setValue,
    getValues,
    handleSubmit: handleSubmit(onSubmit),
    errors,
  };
};
